/**
 * Created by Mark on 21/04/2017.
 */



import ApplicationServices from './base-service.js';
import Constants from '../constants/medals.js';
import Action    from '../actions/default.js';

class MedalsService {

    constructor(){

    }

    getAccountsMedals(){
        return ApplicationServices.call(Constants.GET_ALL_ACCOUNT , {}).then(function(response){
             Action.update(Constants.UPDATE_ACCOUNT_MEDALS , response.medals);
        });
    }

    getClassMedals(classID , language){
        return ApplicationServices.call(Constants.GET_ALL_CLASS , {classID:classID , languageID:language}).then(function(response){
            Action.update(Constants.UPDATE_CLASS_MEDALS_LEVEL , response.medals);
        });
    }

    getStudentMedals(studentID , from ,  to , language)
    {
        return ApplicationServices.call(Constants.GET_STUDENT_TOTAL , {from:from , to:to , languageID:language , studentID:studentID} ).then(function(response){
            Action.update(Constants.UPDATE_STUDENT_MEDALS_TOTAL , response.medals)
        });
    }

}


export default new MedalsService();


// WEBPACK FOOTER //
// ./src/services/medals-service.js